import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';
import { i18n } from '../../translate/i18n';
import { updateEquipments, updateEquipmentsSuccess } from './equipments';
import { requestEquipmentServicesStart, updateEquipmentServicesSuccess, requestEquipmentServicesFail } from './equipmentServices';
let CancelToken = axios.CancelToken;
let fetchEquipmentModel_cancel;
let fetchEquipmentModelById_cancel;
let fetchEquipmentModelExport_cancel;

export const setEquipmentModelsFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_EQUIPMENT_MODEL_FILTER,
    equipmentModelsFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const fetchEquipmentModelsSuccess = (equipmentModels) => {
  return {
    type: actionTypes.FETCH_EQUIPMENT_MODELS_SUCCESS,
    equipmentModels: equipmentModels
  };
};

export const fetchEquipmentModelByIdSuccess = (equipmentModel) => {
  return {
    type: actionTypes.FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS,
    equipmentModel: equipmentModel
  };
}

export const requestEquipmentModelsFail = (error) => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_MODELS_FAIL,
    error: error
  };
};

export const requestEquipmentModelsStart = () => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_MODELS_START
  };
};

export const deleteEquipmentModelsSuccess = (equipmentModel) => {
  return {
    type: actionTypes.DELETE_EQUIPMENT_MODELS_SUCCESS,
    equipmentModel: equipmentModel
  }
}

export const checkDeleteEquipmentModelsSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_EQUIPMENT_MODELS_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateEquipmentModelsSuccess = () => {
  return {
    type: actionTypes.UPDATE_EQUIPMENT_MODELS_SUCCESS,
  }
}

export const postEquipmentModelsSuccess = (equipementsParam) => {
  return {
    type: actionTypes.POST_EQUIPMENT_MODELS_SUCCESS,
    equipementsParam: equipementsParam
  }
}

export const removeServiceEquipmentModelsSuccess = () => {
  return {
    type: actionTypes.REMOVE_SERVICE_EQUIPMENT_MODELS_SUCCESS
  };
};

export const addServiceEquipmentModelsSuccess = () => {
  return {
    type: actionTypes.ADD_SERVICE_EQUIPMENT_MODELS_SUCCESS
  };
};

export const updateEquipmentServiceInModel = (equipmentService) => {
  return {
    type: actionTypes.UPDATE_EQUIPMENT_SERVICE_IN_MODEL,
    equipmentService: equipmentService
  };
};

export const requestCloneEquipmentModelsStart = () => {
  return {
    type: actionTypes.REQUEST_CLONE_EQUIPMENT_MODELS_START
  };
};

export const requestCloneEquipmentModelsSuccess = () => {
  return {
    type: actionTypes.REQUEST_CLONE_EQUIPMENT_MODELS_SUCCESS
  };
};

export const requestCloneEquipmentModelsFail = () => {
  return {
    type: actionTypes.REQUEST_CLONE_EQUIPMENT_MODELS_FAIL,
  };
};

export const requestCloneChecklistStart = () => {
  return {
    type: actionTypes.REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_START
  };
};

export const requestCloneChecklistSuccess = (equipmentModel) => {
  return {
    type: actionTypes.REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_SUCCESS,
    equipmentModel: equipmentModel,
  };
};

export const requestCloneChecklistFail = () => {
  return {
    type: actionTypes.REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_FAIL
  };
};

export const requestDeleteEquipmentServicesChecklistStart = () => {
  return {
    type: actionTypes.REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_START,
  };
};

export const requestDeleteEquipmentServicesChecklistSuccess = (equipmentModel) => {
  return {
    type: actionTypes.REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_SUCCESS,
    equipmentModel,
  };
};

export const requestDeleteEquipmentServicesChecklistFail = () => {
  return {
    type: actionTypes.REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_FAIL,
  };
};

// Attachments list
export const fetchAttachmentFileByIdSuccess = (attachmentFile) => {
  return {
    type: actionTypes.FETCH_ATTACHMENTFILE_BY_ID_SUCCESS,
    attachmentFile,
  };
}

export const requestAttachmentFileDocumentStart = () => {
  return {
    type: actionTypes.REQUEST_ATTACHMENTFILE_DOCUMENT_START
  };
};

export const requestAttachmentFileDocumentFail = (error) => {
  return {
    type: actionTypes.REQUEST_ATTACHMENTFILE_DOCUMENT_FAIL,
    error: error
  };
};

export const deleteChecklistBySite = (equipmentModelId, equipmentServiceId, siteId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestDeleteEquipmentServicesChecklistStart());
      API.delete(`/equipmentservices/${equipmentServiceId}/questions-site/${siteId}`)
        .then(() => {
          toastr.success(i18n.t('deleteChecklistBySiteStr.toastr'));
          dispatch(fetchEquipmentModelById(equipmentModelId));
          resolve('success');
        }).catch(err => {
          dispatch(requestDeleteEquipmentServicesChecklistFail(err));
          resolve('error');
        });
    });
  };
}

export const fetchEquipmentModels = (page, limit, search, order, orderBy, documenttypeId) => {
  fetchEquipmentModel_cancel && fetchEquipmentModel_cancel()

  return dispatch => {
    dispatch(requestEquipmentModelsStart());
    dispatch(setEquipmentModelsFilter(page, limit, search, order, orderBy));
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}${documenttypeId ? `&documenttype=${documenttypeId}` : ''}`;
    API.get('/equipmentmodels' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchEquipmentModel_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchEquipmentModelsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentModelsFail(err));
      });
  };
};


export const fetchEquipmentModelsExport = (search, order, orderBy, emailLanguage) => {
  fetchEquipmentModelExport_cancel && fetchEquipmentModelExport_cancel()

  return dispatch => {
		return new Promise((resolve, reject) => {
			let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
      queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : '&emailLanguage=pt'}`;
			API.get('/equipmentmodels/export' + queryParams, {
				cancelToken: new CancelToken(function executor(c) {
					fetchEquipmentModelExport_cancel = c;
				})
			})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					toastr.error('Erro', err)
					reject(err);
				});
		})
  };
};

export const fetchEquipmentModelById = (id) => {
  fetchEquipmentModelById_cancel && fetchEquipmentModelById_cancel()

  return dispatch => {
    dispatch(requestEquipmentModelsStart());
    API.get('/equipmentmodels/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchEquipmentModelById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchEquipmentModelByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentModelsFail(err));
      });
  };
};

export const deleteEquipmentModels = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentModelsStart());
      API.put('/equipmentmodels/' + index + '/delete')
        .then(res => {
          dispatch(deleteEquipmentModelsSuccess(res.data));
          toastr.success(i18n.t('deleteEquipmentModelsStr.toastr'), `${res.data.name} ${i18n.t('deleteEquipmentModelsStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentModelsFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const checkDeleteEquipmentModels = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentModelsStart());
      API.get('/equipmentmodels/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeleteEquipmentModelsSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestEquipmentModelsFail(err));
          resolve('error');
        });
    })
  }
}

export const postEquipmentModels = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentModelsStart());
      API.post('/equipmentmodels', body)
        .then(res => {
          dispatch(postEquipmentModelsSuccess(res.data));
          toastr.success(i18n.t('postEquipmentModelsStr.toastr'), `${res.data.name} ${i18n.t('postEquipmentModelsStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentModelsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postEquipmentModelsStr.toastrError'), i18n.t('postEquipmentModelsStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const postCloneEquipmentModels = (body, id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCloneEquipmentModelsStart());
      API.post('/equipmentmodels/clone/' + id, body)
        .then(res => {
          dispatch(requestCloneEquipmentModelsSuccess());
          toastr.success(i18n.t('postCloneEquipmentModels.toastr'), `${res.data.name}${i18n.t('postCloneEquipmentModels.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestCloneEquipmentModelsFail());
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postCloneEquipmentModels.toastrError'), i18n.t('postCloneEquipmentModels.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const postCloneChecklist = (body, equipmentId, siteId, id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCloneChecklistStart());
      API.post(`/equipmentmodels/clonechecklist/${equipmentId}/${siteId}/${id}`, body)
        .then(() => {
          toastr.success(i18n.t('postCloneChecklist.toastr'), i18n.t('postCloneChecklist.toastr1'))
          dispatch(fetchEquipmentModelById(equipmentId));
          resolve('success');
        }).catch(err => {
          dispatch(requestCloneChecklistFail());
          if (err.response && err.response.data) {
            if (err.response.data.message === "Already in use") {
              toastr.error(i18n.t('postCloneChecklist.toastrError'), i18n.t('postCloneChecklist.toastrError1'))
            } else if (err.response.data.message === "Empty checklist") {
              toastr.error(i18n.t('postCloneChecklist.toastr1Error'),i18n.t('postCloneChecklist.toastr1Error1'))
            } else {
              toastr.error('Erro', err.response.data.message)
            }
          } else {
            toastr.error('Erro', 'Erro ao clonar checklist')
          }
          resolve('error');
        });
    })
  }
}

export const postCloneChecklistBySite = (body, id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCloneChecklistStart());
      API.post(`/equipmentmodels/clonechecklistbysite/${id}`, body)
        .then(() => {
          toastr.success(i18n.t('postCloneChecklistBySite.toastr'), i18n.t('postCloneChecklistBySite.toastr1'))
          dispatch(fetchEquipmentModelById(id));
          resolve('success');
        }).catch(err => {
          dispatch(requestCloneChecklistFail());
          if (err.response && err.response.data) {
            if (err.response.data.message === 'Checklist contains questions') {
              reject({ site: err.response.data.site })
            } else {
              toastr.error('Erro', err.response.data.message)
            }
          } else {
            toastr.error('Erro', 'Erro ao clonar checklist')
          }
          resolve('error');
        });
    })
  }
}

export const updateEquipmentModels = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentModelsStart());
      API.put('/equipmentmodels/' + index, body)
        .then(res => {
          dispatch(updateEquipmentModelsSuccess());
          toastr.success(i18n.t('updateEquipmentModels.toastr'), `${res.data.name}${i18n.t('updateEquipmentModels.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentModelsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateEquipmentModels.toastrError'), i18n.t('updateEquipmentModels.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const removeServiceEquipmentModels = (index, equipServiceId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentModelsStart());
      API.put('/equipmentmodels/' + index + '/removeequipmentservice/' + equipServiceId)
        .then(res => {
          dispatch(removeServiceEquipmentModelsSuccess());
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentModelsFail(err));
          resolve('error');
        });
    })
  }
}

export const addServiceEquipmentModels = (index, equipServiceId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentModelsStart());
      API.put('/equipmentmodels/' + index + '/addequipmentservice/' + equipServiceId)
        .then(res => {
          dispatch(addServiceEquipmentModelsSuccess());
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentModelsFail(err));
          resolve('error');
        });
    })
  }
}

export const handleManageAttachments = (index, body, handleType) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestAttachmentFileDocumentStart());
      API.post('/equipmentmodels/' + index + '/adddocument', body)
        .then(res => {
          dispatch(fetchAttachmentFileByIdSuccess(res.data));
          handleType === 'new' && toastr.success(i18n.t('handleAttachFile.toastrCreateTitle'), i18n.t('handleAttachFile.toastrCreateMessage'))
          handleType === 'edit' && toastr.success(i18n.t('handleAttachFile.toastrEditTitle'), i18n.t('handleAttachFile.toastrEditMessage'))
          handleType === 'delete' && toastr.success(i18n.t('handleAttachFile.toastrDeleteTitle'), i18n.t('handleAttachFile.toastrDeleteMessage'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestAttachmentFileDocumentFail(err));
          handleType === 'new' && toastr.error(i18n.t('handleAttachFile.toastrCreateErrorTitle'), i18n.t('handleAttachFile.toastrCreateErrorMessage'))
          handleType === 'edit' && toastr.error(i18n.t('handleAttachFile.toastrEditErrorTitle'),i18n.t('handleAttachFile.toastrEditErrorMessage'))
          handleType === 'delete' && toastr.error(i18n.t('handleAttachFile.toastrDeleteErrorTitle'),i18n.t('handleAttachFile.toastrDeleteErrorMessage'))
          resolve('error');
        });
    })
  }
}
